module.exports = __webpack_public_path__ + "img/ic-view-detail.d1b4fc54.svg";